// Import dependencies
import React, { useState, useEffect } from 'react';

// Import CSS & assets
import './VideoDemo.css';
import video_demo from '../../../assets/videos/video_demo_comp.mp4';
import mask from '../../../assets/mask_progress_bar.svg';

const chapters = [
    { time: 0, progress: 0 },
    { time: 25, progress: (100 / 7) + 0.05 },
    { time: 40, progress: ((100 / 7) * 2) + 0.15 },
    { time: 55, progress: ((100 / 7) * 3) + 0.25 },
    { time: 144, progress: ((100 / 7) * 4) + 0.3 },
    { time: 215, progress: ((100 / 7) * 5) + 0.35},
    { time: 227, progress: ((100 / 7) * 6) + 0.45 },
]
const video_duration = 248;

const VideoDemo = () => {

    const [progressWidth, setProgressWidth] = useState(0);
    const [currentChapter, setCurrentChapter] = useState(0);

    const video_play = () => {
        document.getElementById("video_demo").play();
        document.getElementById("video_demo").setAttribute("controls", "controls");
    }

    const video_stop = () => {
        document.getElementById("video_demo").pause();
        document.getElementById("video_demo").removeAttribute("controls");
    }

    const video_setTime = (time) => {
        document.getElementById("video_demo").currentTime = time;
        video_play();
    }

    const chapter_change = (index) => {
        var chapter_data = chapters[index];
        video_setTime(chapter_data.time);
        setCurrentChapter(index);
        setProgressWidth(chapter_data.progress);
    }

    const options = {
        root: null,
        rootMargin: "0px",
        scrollMargin: "0px",
        threshold: 1.0,
    };
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting === true) {
                video_play();
            }
            else {
                video_stop();
            }
        });
    };
    const observer = new IntersectionObserver(callback, options);

    useEffect(() => {
        // Set observer
        observer.observe(document.getElementById("video_demo_box"));
        // Set video time tracker
        document.getElementById("video_demo").addEventListener("timeupdate", (event) => {
            var currentTime = event.target.currentTime;
            // console.log("video_time", currentTime);
            try {
                // Search current chapter
                var currentChapterSearch = null;
                for (var i = 1; i < chapters.length; i++) {
                    currentChapterSearch = i;
                    if (currentTime < chapters[i].time) {
                        currentChapterSearch = i - 1;
                        break;
                    }
                }
                if (currentChapterSearch >= 0) {
                    // Set current chapter
                    setCurrentChapter(currentChapterSearch);
                    // Set progress
                    var time_start = chapters[currentChapterSearch].time;
                    var time_end = video_duration;
                    if (currentChapterSearch < (chapters.length - 1)) { time_end = chapters[currentChapterSearch + 1].time }
                    var chapter_progress = 100 * ((currentTime - time_start) / (time_end - time_start));
                    var progress_start = chapters[currentChapterSearch].progress;
                    var progress_end = 100;
                    if (currentChapterSearch < (chapters.length - 1)) { progress_end = chapters[currentChapterSearch + 1].progress }
                    var progress_delta = (chapter_progress / 100) * (progress_end - progress_start);
                    var progress_global = Math.min(progress_start + progress_delta, 100);
                    setProgressWidth(progress_global);
                }
            } catch (error) {
                console.log("error video time tracking", error);
            }
        })
    }, []);

    return (
        <div className="landing__videodemo">
            <div className="landing__videodemo_container">
                <div id="video_demo_box" className="landing__videodemo_video">
                    <video id="video_demo" src={video_demo} muted disablePictureInPicture controlsList="nodownload" />
                </div>
            </div>
            <div className="landing__videodemo_chapter_container_main">
                <div className="landing__videodemo_chapter_container">
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(0) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 0 ? "landing__videodemo_chapter_label_light_1" : ""}`}>Sélection des parcelles</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(1) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 1 ? "landing__videodemo_chapter_label_light_2" : ""}`}>Analyse du foncier</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(2) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 2 ? "landing__videodemo_chapter_label_light_3" : ""}`}>Analyse des risques</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(3) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 3 ? "landing__videodemo_chapter_label_light_4" : ""}`}>Analyse du contexte</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(4) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 4 ? "landing__videodemo_chapter_label_light_5" : ""}`}>Règles d'urbanisme</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(5) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 5 ? "landing__videodemo_chapter_label_light_6" : ""}`}>Calcul capacitaire</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                    <div className="landing__videodemo_chapter_box_spacer"><img src={mask} /></div>
                    <div className="landing__videodemo_chapter_box" onClick={() => { chapter_change(6) }}>
                        <div className={`landing__videodemo_chapter_label ${currentChapter >= 6 ? "landing__videodemo_chapter_label_light_7" : ""}`}>Simulations</div>
                        <div className="landing__videodemo_chapter_progress_box"><div className="landing__videodemo_chapter_progress_fill" style={{ width: '0%' }}></div></div>
                    </div>
                </div>
                <div className="landing__videodemo_chapter_progress_global" style={{ width: progressWidth + '%' }}></div>
            </div>
        </div>
    );
};

export default VideoDemo;